import * as XLSX from 'xlsx';

export const prepareImportReview = preview => ({
    ...preview,
    rows: (preview.rows || []).map(row => ({
        ...row, isException: row.status !== 'Success', originalMessage: row.message, skip: false
    }))
});

export const getImportExceptions = rows => rows.filter(row => row.isException);

export const getImportSummary = rows => ({
    total: rows.length,
    normal: rows.filter(row => !row.isException).length,
    resolved: rows.filter(row => row.isException && !row.skip && row.status === 'Success').length,
    skipped: rows.filter(row => row.skip).length,
    pending: rows.filter(row => !row.skip && (row.status !== 'Success' || !row.selectedShipmentIds?.length)).length,
    write: rows.filter(row => !row.skip && row.status === 'Success' && row.selectedShipmentIds?.length).length
});

export function buildImportCommit(rows, billDate, confirmSkipped) {
    const summary = getImportSummary(rows);
    if (summary.pending) throw new Error('仍有異常尚未指定出貨明細或確認略過。');
    if (summary.skipped && !confirmSkipped) throw new Error('請勾選確認略過清單。');
    if (!summary.write) throw new Error('沒有可寫入的資料。');
    const used = new Set();
    rows.filter(row => !row.skip).forEach(row => row.selectedShipmentIds.forEach(id => {
        if (used.has(id)) throw new Error(`出貨明細 ID ${id} 重複選取，請重新確認。`);
        used.add(id);
    }));
    return {
        billDate, confirmSkipped,
        rows: rows.map(row => ({
            rowNumber: row.rowNumber, billNum: row.billNum, orderNum: row.orderNum,
            serialNum: row.serialNum, quantity: row.quantity, skip: !!row.skip,
            shipmentIds: row.skip ? [] : row.selectedShipmentIds
        }))
    };
}

export function buildExceptionWorkbook(rows) {
    const exceptions = getImportExceptions(rows);
    const report = exceptions.map(row => ({
        Excel列號: row.rowNumber, 發票號碼: row.billNum, 訂單號碼: row.orderNum, 流水號: row.serialNum,
        數量: row.quantity, 異常原因: row.originalMessage,
        處理結果: row.skip ? '確認略過' : row.status === 'Success' ? '已指定明細' : '尚未處理',
        選取出貨ID: (row.selectedShipmentIds || []).join('、')
    }));
    const details = exceptions.flatMap(row => [
        ...(row.candidates || []).flatMap(candidate => candidate.lines.map(line => ({
            Excel列號: row.rowNumber, 候選組合: candidate.key, 出貨ID: line.id, 出貨單: line.shipNum,
            日期: line.shipDate, 批號: line.batchNum, 圖號: line.drawNum, 數量: line.quantity
        }))),
        ...(row.selectedLines || []).map(line => ({
            Excel列號: row.rowNumber, 候選組合: '手動指定', 出貨ID: line.id, 出貨單: line.shipNum,
            日期: line.shipDate, 批號: line.batchNum, 圖號: line.drawNum, 數量: line.quantity
        }))
    ]);
    const book = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(book, XLSX.utils.json_to_sheet(report, {
        header: ['Excel列號', '發票號碼', '訂單號碼', '流水號', '數量', '異常原因', '處理結果', '選取出貨ID']
    }), '異常清單');
    XLSX.utils.book_append_sheet(book, XLSX.utils.json_to_sheet(details, {
        header: ['Excel列號', '候選組合', '出貨ID', '出貨單', '日期', '批號', '圖號', '數量']
    }), '候選明細');
    return book;
}

export function downloadImportExceptions(rows, company) {
    XLSX.writeFile(buildExceptionWorkbook(rows), `${company || ''}_發票匯入異常.xlsx`);
}
